export default __webpack_public_path__ + "static/media/bd-home-large.756ceb5b.png";